import { render, staticRenderFns } from "./QuestionDialog.vue?vue&type=template&id=7a8d3f91&scoped=true"
import script from "./QuestionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuestionDialog.vue?vue&type=style&index=0&id=7a8d3f91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8d3f91",
  null
  
)

export default component.exports